export type Tab = {
  value: TAB_OPTIONS;
  icon: string;
};

export enum TAB_OPTIONS {
  RFI_DETAILS = 'RFI Details',
  DISCUSSIONS = 'Discussions',
  PACKAGE_DETAILS = 'Package Details',
  SUBMITTALS = 'Submittals',
  TRANSMITTAL_LOG = 'Transmittal Log',
}
